import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import {
  leftMenuHeaderOption,
  defaultStackHeaderOptions,
  allowStackToScrollOnWebOption,
} from '../utils/defaultNavOptions';
import SettingsScreen from '../screens/SettingsScreen';
import NotificationModal from '../components/settings/NotificationModal';
import AboutModal from '../components/settings/AboutModal';
import LegalModal from '../components/settings/LegalModal';
import TermsModal from '../components/settings/legal/TermsModal';
import PrivacyModal from '../components/settings/legal/PrivacyModal';
import { useTranslation } from 'react-i18next';
import { Screens } from '../constants/ScreenNames';

const SettingsStack = createStackNavigator();

const settingsScreenOptions = (props, t) => {
  return {
    ...leftMenuHeaderOption(props),
    title: t('MainNavigator.SettingsDrawerTitle'),
  };
};

export const SettingsNavigator = () => {
  const { t } = useTranslation();
  return (
    <SettingsStack.Navigator
      screenOptions={{ ...defaultStackHeaderOptions, ...allowStackToScrollOnWebOption }}
    >
      <SettingsStack.Screen
        name={Screens.Settings}
        component={SettingsScreen}
        options={(props) => settingsScreenOptions(props, t)}
      />
      <SettingsStack.Screen
        name={Screens.Notification}
        component={NotificationModal}
        options={{
          title: t('SettingsNavigator.Notification'),
        }}
      />
      <SettingsStack.Screen
        name={Screens.About}
        component={AboutModal}
        options={{
          title: t('SettingsNavigator.About'),
        }}
      />
      <SettingsStack.Screen
        name={Screens.Legal}
        component={LegalModal}
        options={{
          title: t('SettingsNavigator.Legal'),
        }}
      />
      <SettingsStack.Screen
        name={Screens.TermsOfUse}
        component={TermsModal}
        options={{
          title: t('SettingsNavigator.Terms'),
        }}
      />
      <SettingsStack.Screen
        name={Screens.PrivacyPolicy}
        component={PrivacyModal}
        options={{
          title: t('SettingsNavigator.Privacy'),
        }}
      />
    </SettingsStack.Navigator>
  );
};
